import { ActionType, Slug } from "../constants";
import * as apiService from "../service/ApiService";

// called when the youtube script is loaded
export const loadedYtScript = (dispatch) => () => {
  dispatch({
    type: ActionType.loadedYtScript,
  });
};

// called when an eduId does not exist on server
export const eduIdNotFound = (dispatch, eduId) => () => {
  dispatch({
    type: ActionType.eduIdNotFound,
    payload: eduId,
  });
};

export const clearError = (dispatch) => {
  dispatch({
    type: ActionType.error,
    payload: { error_code: null, uncaughtError: null },
  });
};

export const updateAppData = (dispatch, data) => {
  dispatch({
    type: ActionType.updateAppData,
    payload: data,
  });
};
export const updateApplyData = (dispatch, data) => {
  dispatch({
    type: ActionType.updateApplyData,
    payload: data,
  });
};
export const alreadyApplied = (navigate) => {
  navigate(Slug.alreadyApplied);
};

export const setAllChats = (dispatch, allChats) => {
  dispatch({
    type: ActionType.setAllChats,
    payload: allChats,
  });
};
export const updateAllChats = (dispatch, allChats) => {
  dispatch({
    type: ActionType.updateAllChats,
    payload: allChats,
  });
};
export const selectChat = (dispatch, chat) => {
  dispatch({
    type: ActionType.selectChat,
    payload: chat,
  });
};
export const setFullChat = (dispatch, chat) => {
  dispatch({
    type: ActionType.setFullChat,
    payload: chat,
  });
};

export const setChatInput = (dispatch, message) => {
  dispatch({
    type: ActionType.setChatInput,
    payload: message,
  });
};

export const newChatMessage = (dispatch, chatMessage) => {
  dispatch({
    type: ActionType.appendChatHistory,
    payload: { ...chatMessage, senderIsApplicant: true },
  });
};

export const successLocalMessage = (
  dispatch,
  localId,
  receipientId,
  serverId
) => {
  dispatch({
    type: ActionType.successLocalMessage,
    payload: { localId, receipientId, serverId },
  });
};
export const failLocalMessage = (dispatch, localId, receipientId) => {
  dispatch({
    type: ActionType.failLocalMessage,
    payload: { localId, receipientId },
  });
};
export const retryLocalMessage = (dispatch, localId, receipientId) => {
  dispatch({
    type: ActionType.retryLocalMessage,
    payload: { localId, receipientId },
  });
};
export const fetchResumeUrl = (dispatch, accountData, resumeId) => {
  apiService.getResumeUrl(
    dispatch,
    {
      ...accountData,
      resumeId,
    },
    {}
  );
};

export const setProfilePicUrl = (dispatch, url, scale) => {
  dispatch({
    type: ActionType.setProfilePicUrl,
    payload: { url, scale },
  });
};

export const setNumUnread = (dispatch, numUnread) => {
  dispatch({
    type: ActionType.setNumUnread,
    payload: { numUnread },
  });
};

export const removeLocalJobById = (dispatch, jobId) => {
  dispatch({
    type: ActionType.removeLocalJobById,
    payload: jobId,
  });
};
